import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { AttachmentType } from '../../models/misc.model';
import { UploadService } from '../../services/upload.service';
import { KakaotalkTemplateMessageContent } from './models/kakaotalk-template-message-content.model';

@Component({
  selector: 'app-message-kakaotalk-template',
  templateUrl: './message-kakaotalk-template.component.html',
  styleUrls: ['./message-kakaotalk-template.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MessagekakaotalkTemplateComponent implements OnInit {
  @Input() message: KakaotalkTemplateMessageContent;
  templateDisplayedBS: BehaviorSubject<FormGroup> = new BehaviorSubject(null);

  constructor(private uploadService: UploadService) {}

  ngOnInit(): void {
    const form: FormGroup = new FormGroup({
      header: new FormGroup({
        media_type: new FormControl(),
        media_url: new FormControl(),
      }),
      body: new FormControl({}),
      buttons: new FormArray([]),
    });

    const { attachment, body } = this.message;
    if (attachment) {
      const { buttons, image } = attachment;

      (buttons || []).forEach(button => {
        if (!Array.isArray(button.example)) {
          button.example = [button.example];
        }
        const buttonForm = new FormGroup({
          text: new FormControl(),
          type: new FormControl(),
          url: new FormControl(),
        });
        buttonForm.patchValue(button);
        (form.get('buttons') as FormArray).push(buttonForm);
      });

      if (image) {
        const { media_id } = image;
        const media_url = this.uploadService.pictureUrl(media_id);

        form.get('header').setValue({
          media_type: AttachmentType.Image,
          media_url,
        });
      }
    }

    form.patchValue({ body });
    this.templateDisplayedBS.next(form);
  }
}
